import { render } from "./who_to_follow.vue?vue&type=template&id=66556454"
import script from "./who_to_follow.js?vue&type=script&lang=js"
export * from "./who_to_follow.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__